<kendo-dialog *ngIf="recordDetailDialog" title="Record Detail" id="recordDetailDialog" class="record-detail-dialog"
  (close)="closeDetailDialog()" [minWidth]="500">
  <div class="adj-dialog-IE">
    <div *ngIf="isErr" class="bottom-margin-10">
      <h2 class="margin-0">Errors:</h2>
      <ul class="recordIssues">
        <li *ngFor="let error of recordErrors"><span class="k-icon k-i-error text-red"></span>
          {{error}}
        </li>
      </ul>
    </div>
    <div *ngIf="isIssue" class="issue-container">
      <h2 class="header-tag">Warnings:</h2>
      <ul class="recordIssues">
        <li *ngFor="let issue of recordIssues"><span class="k-icon k-i-warning text-warning"></span>
          {{issue}}
        </li>
      </ul>
    </div>
    <br>
    <table class="keyValuePairs" aria-hidden="true">
      <tbody class="alignLeft">
        <tr>
          <th class="shaded" colspan="2">Personal Details</th>
        </tr>
        <tr>
          <th>Social Security Number</th>
          <td>{{selectedRecord.ssn}}</td>
        </tr>
        <tr>
          <th>Last Name</th>
          <td>{{selectedRecord.lastName}}</td>
        </tr>
        <tr>
          <th>First Name</th>
          <td>{{selectedRecord.firstName}}</td>
        </tr>
        <tr>
          <th>Middle Initial</th>
          <td>{{selectedRecord.middleInitials}}</td>
        </tr>
        <tr>
          <th class="shaded" colspan="2">Membership</th>
        </tr>
        <tr>
          <th>Location</th>
          <td>{{selectedRecord.locationCode}}</td>
        </tr>
        <tr>
          <th>System Code</th>
          <td>{{selectedRecord.systemCode}}</td>
        </tr>
        <tr>
          <th class="remove-border">Reason Code</th>
          <div *ngFor="let reason of selectedRecord?.reasonCodeArray">
            <td class="remove-border">{{reason.reasonCode}}</td>
          </div>
        </tr>
        <tr>
          <th class="shaded" colspan="2">Pay</th>
        </tr>
        <tr>
          <th>Pay Period Beginning Date</th>
          <td>{{selectedRecord.payPeriodBeginningDate | date: "MM/dd/yyyy"}}</td>
        </tr>
        <tr>
          <th>Pay Period End Date</th>
          <td>{{selectedRecord.payPeriodEndDate | date: "MM/dd/yyyy"}}</td>
        </tr>
        <tr>
          <th>Actual Annual Compensation</th>
          <td>{{selectedRecord.actualAnnualCompensation | currency}}</td>
        </tr>
        <tr>
          <th>Annual Earnable Compensation</th>
          <td>{{selectedRecord.actualEarnableCompensation | currency}}</td>
        </tr>
        <tr>
          <th>Employee Contribution</th>
          <td [ngClass]=" 0 > selectedRecord.employeeContribution ? 'neg-amount' : ''">{{selectedRecord.formatAmount}}
          </td>
        </tr>
        <tr>
          <th>Pay Period Base Salary</th>
          <td>{{selectedRecord.payPeriodBaseSalary | currency}}</td>
        </tr>
        <tr>
          <th>Hours Worked</th>
          <td>{{selectedRecord.hoursWorked}}</td>
        </tr>
        <tr>
          <th>Standard Hours</th>
          <td>{{selectedRecord.standardHours}}</td>
        </tr>
        <tr>
          <th>Percentage of Time</th>
          <td>{{selectedRecord.percentFullTime }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</kendo-dialog>
